import { render, staticRenderFns } from "./relatorioChamada.vue?vue&type=template&id=8d8c0576"
import script from "./relatorioChamada.vue?vue&type=script&lang=js"
export * from "./relatorioChamada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports